import { createSlice } from '@reduxjs/toolkit';
type inner = 'body' | 'infoDetail' | 'child'
interface handleLoansTabComponents {
    prevState: string;
    nextState: string;

}
const initialState = {
    prevState: '',
    nextState: '',

};

export const loansTabComponentsSlice = createSlice({
    name: 'LoansTabComponents',
    initialState,
    reducers: {
        getpervStateTab: (state: handleLoansTabComponents, action: any) => {
            state.prevState = action.payload.prevState;
        },
        getNextStateTab: (state: handleLoansTabComponents, action: any) => {
            state.nextState = action.payload.nextState;
        },

    },
});

export const { getpervStateTab, getNextStateTab }: any = loansTabComponentsSlice.actions;

export default loansTabComponentsSlice.reducer;
